import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import EmailLink from "@/components/EmailLink";
import { Section, Overline, H1, Lead, Card } from "@/components/ui-kit";
import ContactForm from "@/components/forms/ContactForm";

export default function Contact() {
  const [params] = useSearchParams();
  const subject = params.get("subject") || "";
  return (
    <>
      <Section className="pt-12 md:pt-20 pb-8 md:pb-10">
        <Overline>Contact</Overline>
        <H1 className="mt-5 max-w-4xl">Let's talk.</H1>
        <Lead className="mt-7 max-w-3xl">
          Sellers, investors, buyers, and strategic partners: start with a short message and we'll route you to the
          right next step.
        </Lead>
      </Section>

      <Section className="py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card><div className="overline">Sellers</div><Link to="/sell" className="block font-display text-xl mt-3 hover:text-[#C19B6C]">Sell Your Property →</Link></Card>
          <Card><div className="overline">Investors</div><Link to="/investors" className="block font-display text-xl mt-3 hover:text-[#C19B6C]">Investor Interest →</Link></Card>
          <Card><div className="overline">Buyers</div><Link to="/buyers" className="block font-display text-xl mt-3 hover:text-[#C19B6C]">Join Buyer List →</Link></Card>
        </div>
      </Section>

      <Section className="py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div>
            <div className="overline">Acquisitions</div>
            <div className="mt-3 text-neutral-200"><EmailLink email="acquisitions@brightsidecapital.net" testId="contact-acq-email" /></div>
            <div className="overline mt-8">Investors</div>
            <div className="mt-3 text-neutral-200"><EmailLink email="invest@brightsidecapital.net" testId="contact-invest-email" /></div>
            <div className="overline mt-8">Service Areas</div>
            <p className="text-sm text-neutral-400 mt-3 leading-relaxed">
              Sacramento, North Sacramento, Del Paso Heights, Roseville, Rocklin, Lincoln, Citrus Heights, Rancho Cordova,
              Elk Grove, Sacramento County, Placer County.
            </p>
          </div>
          <div className="lg:col-span-2"><ContactForm key={subject} initialMessage={subject ? `I would like to discuss a project similar to "${subject}".\n\n` : ""} /></div>
        </div>
      </Section>
    </>
  );
}
